<app-card-lg [title]="'Products'">
  <div *appLoading="loading$ | async"></div>
  @if (!(loading$ | async)) {
    @for (product of (products$ | async); track product) {
      <app-products-list-item [product]="product"></app-products-list-item>
    }
  }
</app-card-lg>
